<div>
    <div>
        <cmps-frontline-mi2
            *ngIf="cameFromFlMI2 == false"
            [selectedUser]="selecteduser"
            (selectedUserChange)="handleCurrentViewChange($event)"
        >
        </cmps-frontline-mi2>
    </div>
    <div class="row fl-mi2-population">
        <div class="col-12">
            <button
                *ngIf="cameFromFlMI2 == true"
                (click)="goBackToStoredFavourite()"
                class="btn legend-button"
            >
                <cmps-icon svgIcon="reply"></cmps-icon>
                <span>{{
                    i18n._7495_BACK_TO_PREVIOUS_VIEW___ | translate
                }}</span>
            </button>
            <cmps-mi2-main
                *ngIf="cameFromFlMI2 == true"
                [userId]="tlUserId"
            >
            </cmps-mi2-main>
        </div>
    </div>
</div>
